import {Injectable} from '@angular/core';
import {LineChartDataParams, UpdateLineChartParams} from "../types/line-chart-modal.types";
import {defaultLineChartQueryParams} from "../configs/line-chart-modal-config";

@Injectable({
  providedIn: 'root'
})
export class LineChartDayService {
  public setLineChartDataParams(updateLineChartParams: UpdateLineChartParams, parentUrl: string): LineChartDataParams {
    const queryParams = {
      ...defaultLineChartQueryParams,
      sort: [
        'date,asc'
      ],
      ...updateLineChartParams.selectedProductId ? { productId: updateLineChartParams.selectedProductId } : {},
      ...updateLineChartParams.selectedArticleId ? { article: updateLineChartParams.selectedArticleId } : {},
      dateFrom: updateLineChartParams.rangeData.dateFrom,
      dateTo: updateLineChartParams.rangeData.dateTo
    };

    return {
      path: parentUrl,
      queryParams: queryParams
    };
  }
}
